define.alias("shared/components/shared/profile-categorization/banner", "media/components/shared/profile-categorization/banner");